import type { SVGProps } from "react";
import * as React from "react";

export const EmailIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 5.25C19.2392 5.25 20.25 6.26079 20.25 7.5V16.5C20.25 17.7392 19.2392 18.75 18 18.75H6C4.76079 18.75 3.75 17.7392 3.75 16.5V7.5C3.75 6.26079 4.76079 5.25 6 5.25H18ZM12.4299 13.3645C12.1718 13.5451 11.8282 13.5451 11.5701 13.3645L5.25 8.93994V16.5C5.25 16.9108 5.58921 17.25 6 17.25H18C18.4108 17.25 18.75 16.9108 18.75 16.5V8.93994L12.4299 13.3645ZM6 6.75C5.70896 6.75 5.45457 6.92065 5.33057 7.16602L12 11.8345L18.6687 7.16602C18.5446 6.92081 18.2909 6.75 18 6.75H6Z"
      fill="currentColor"
    />
  </svg>
);
